// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1kw_T","title":"Images45_title__RLDe7","images":"Images45_images__1oQ5D"};